module.exports = __webpack_public_path__ + "img/DM.a3ba398f.png";